import {
  allOf,
  canAddContacts,
  canViewContacts,
  isDesktop,
} from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

const SETTLED_PAGE_WAIT_MS = 600;

export const contactsSteps: TourStepConfig[] = [
  {
    id: "contacts-add-btn",
    target: "contacts.addBtn",
    title: "Add a contact",
    content:
      "Save someone once and they autocomplete every time you build a request, instead of retyping their email.",
    placement: "bottom",
    when: canAddContacts,
  },
  {
    id: "contacts-bulk-upload",
    target: "contacts.bulkUpload",
    title: "Import from CSV",
    content:
      "Bring an existing address book in with one upload, instead of adding people one at a time.",
    placement: "bottom",
    when: canAddContacts,
  },
  {
    id: "contacts-list",
    target: "contacts.list",
    title: "Your contacts",
    content:
      "This is where your contacts live, searchable by name or email. They're also saved automatically as you send requests, so the list fills itself in.",
    placement: "auto",
    targetWaitTimeout: SETTLED_PAGE_WAIT_MS,
    when: canViewContacts,
  },
  {
    id: "contacts-details",
    target: "contacts.details",
    title: "Contact details",
    content:
      "Select someone to see and edit their name, email, phone and address on one record.",
    placement: "left",
    targetWaitTimeout: SETTLED_PAGE_WAIT_MS,
    when: allOf(canViewContacts, isDesktop),
  },
];

export default contactsSteps;
